import { FunctionComponent, useState } from 'react';
import styles from './General.module.scss';
import classNames from 'classnames';
import ToggleSwitch from '../../../../../../components/inputs/ToggleSwitch/ToggleSwitch';
import RadioSwitch from '../../../../../../components/inputs/RadioSwitch/RadioSwitch';
import MainButton from '../../../../../../components/buttons/MainButton/MainButton';
import { ReactComponent as ExternalLinkIcon } from '../../../../../../asset/images/icons/external_link.svg';
import { useNavigate } from 'react-router-dom';
import RoutesEnum from '../../../../../../enums/routes';
import RadioList from '../../../../../../components/inputs/RadioList/RadioList';
import useMediaQuery from '../../../../../../hooks/useMediaQuery';

const testData_1 = [
  { label: 'Immediate', value: '0' },
  { label: 'Daily Summary', value: '1' },
  { label: 'Weekly Summary', value: '2' },
];

interface GeneralProps {}

const General: FunctionComponent<GeneralProps> = () => {
  const navigate = useNavigate();

  const [emailNotif, setEmailNotif] = useState(true);
  const [pushNotif, setPushNotif] = useState(true);

  const [test1, setTest1] = useState(true);
  const [test2, setTest2] = useState(true);
  const [test3, setTest3] = useState(true);

  const [switchState_1, setSwitchState_1] = useState(testData_1[0].value);

  const isMobile = useMediaQuery('(max-width: 767px)');

  return (
    <section className={styles['section']}>
      <div className={styles['tile-list']}>
        <div className={classNames(styles['tile'], 'tile')}>
          <p className={classNames(styles['title'], 'text text--caption text--bold')}>Notifications</p>

          <label className={styles['toggle-input']}>
            <ToggleSwitch checked={emailNotif} onChange={setEmailNotif} size="large" />

            <span className={classNames(styles['toggle-input__label'], classNames('text text--body-2'))}>
              Email Notifications
            </span>
          </label>

          <label className={styles['toggle-input']}>
            <ToggleSwitch checked={pushNotif} onChange={setPushNotif} size="large" />

            <span className={classNames(styles['toggle-input__label'], classNames('text text--body-2'))}>
              Push Notifications
            </span>
          </label>
        </div>

        <div className={classNames(styles['tile'], 'tile')}>
          <div className={styles['parts']}>
            <div className={styles['parts__left']}>
              <p className={classNames(styles['title'], 'text text--caption text--bold')}>Communication Preferences</p>

              <label className={styles['toggle-input']}>
                <ToggleSwitch checked={test1} onChange={setTest1} size="large" disabled />

                <span className={classNames(styles['toggle-input__label'], classNames('text text--body-2'))}>
                  Event Updates
                </span>
              </label>

              <label className={styles['toggle-input']}>
                <ToggleSwitch checked={test2} onChange={setTest2} size="large" />

                <span className={classNames(styles['toggle-input__label'], classNames('text text--body-2'))}>
                  Marketing Communications
                </span>
              </label>

              <label className={styles['toggle-input']}>
                <ToggleSwitch checked={test3} onChange={setTest3} size="large" />

                <span className={classNames(styles['toggle-input__label'], classNames('text text--body-2'))}>
                  Newsletters
                </span>
              </label>
            </div>

            <div className={styles['parts__right']}>
              <p className={classNames(styles['label-1'], 'text text--body-2 text--bold')}>Notification Frequency</p>

              {isMobile ? (
                <RadioList
                  data={testData_1}
                  name="test"
                  onChange={(data) => setSwitchState_1(data.value)}
                  checkedValue={switchState_1}
                />
              ) : (
                <RadioSwitch name="test" onChange={setSwitchState_1} options={testData_1} selected={switchState_1} />
              )}
            </div>
          </div>
        </div>

        <div className={classNames(styles['tile'], 'tile')}>
          <p className={classNames(styles['title'], 'text text--caption text--bold')}>Edit Profile</p>

          <p className={classNames(styles['text'], 'text text--body-2')}>
            To make changes to your profile settings—like your business type, industry, or other details—just click the
            button below. You’ll be redirected to astronomic.com where you can easily update your information and ensure
            we’re matching you with the right group for future dinners.
          </p>

          <MainButton
            sizeType="medium"
            iconRight={<ExternalLinkIcon style={{ width: '16px' }} />}
            onClick={() => {
              navigate(`/${RoutesEnum.ACCOUNT}/${RoutesEnum.PROFILE}#account`);
            }}
          >
            Edit profile
          </MainButton>
        </div>
      </div>
    </section>
  );
};

export default General;
